export enum EntityNameEnum {
    order = 'ORDER',
    person = 'PERSON',
    price = 'PRICE',
    work = 'WORK',
    category = 'CATEGORY',
    project = 'PROJECT',
    location = 'LOCATION',
    item = 'ITEM',
    customFieldsConfig = 'CUSTOM-FIELDS',
    company = 'COMPANY',
}
